import { createContext } from 'react'
import { TSize } from 'src/types'

export type TabsDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse'
export type TabsVariant = 'transparent' | 'transparent-inverted' | 'filled'

export interface TabsContextProps {
  direction: TabsDirection
  variant: TabsVariant
  fullWidth: boolean
  size: TSize
  value?: string
  onChange: (id: string) => void
  setTabRefs: (element: HTMLElement, value: string) => void
  tabsRef: React.MutableRefObject<{
    [key: string]: HTMLElement | null
  }>
  wrapperId: string
}

export const TabsContext = createContext<TabsContextProps>({} as TabsContextProps)
